export { RealEstateDetail } from './RealEstateDetail';
